import Highlight from '../components/Highlight';

import Counter from '../demo/Counter';
import Heading from '../components/Heading';

const Getters = () => {
  return (
    <div>
      <p>
        Use getters to access your current state's values. You can also use getters for computed logic.
      </p>
      <Highlight language="javascript">
        {indexCode}
      </Highlight>

      <hr />

      <Heading>useGetter</Heading>
      <h3 className="heading-types">
        useGetter&lt;T&gt;(getterName: string) => T
      </h3>
      <p>
        The getters are used with the <code>useGetter()</code> hook. Your component will be notified only of the change connected to your consumed getters.
      </p>
      <Highlight language="javascript">
        {componentCode}
      </Highlight>

      <hr />

      <p>
        Open the console to see the render lifecycle of two <code>Counter</code> components, each attached to its own getter. You can see that updating one counter won't trigger the other counter's re-render.
      </p>

      <Counter />

      <hr />

      <Heading>useGetter with modules</Heading>
      <p>
        To access a module's getter, use the module name as the prefix.
        <br />
        <code>const value = useGetter('counter/value')</code>
      </p>
      <Highlight language="javascript">
        {storeModulesCode}
      </Highlight>
    </div>
  )
}

const indexCode = `const store = {
  state: {
    counter1: 1,
    counter2: 2
  },
  getters: {
    counter1 (state) {
      return state.counter1
    },
    counter2 (state) {
      return state.counter2
    },
    counterSum (state) {
      return state.counter1 + state.counter2
    }
  }
}
`

const componentCode = `import { useGetter } from 'vuex-but-for-react'

const Counter1 = () => {
  const count = useGetter('counter1');
  
  return (
    <div>{count}</div>
  )
}`

const storeModulesCode = `const store = {
  state: {
    ...
  },
  getters: {
    ...
  },
  modules: {
    counter: {
      state: { count: 0 },
      getters: {
        value (state) {
          // a module does not have access to the parent state
          return state.count
        }
      }
    }
  }
}
`

export default Getters;
